<div class="color-line"></div>

<div *ngIf="user | auth">
  <div id="logo" class="light-version" style="padding-top: 5px">
    <a><img src="assets/images/LMNLogo-XSmall-Dark.png" /> </a>
  </div>
  <nav role="navigation">
    <div class="header-link" (click)="minimize()">
      <i class="fa fa-bars"></i>
    </div>
    <div class="small-logo">
      <span class="text-primary"><a>LMN</a></span>
    </div>
    <div class="navbar-right">
      <ul class="nav navbar-nav no-borders">
        <li class="dropdown">
          <a (click)="logout()">
            <i class="pe-7s-upload pe-rotate-90"></i>
          </a>
        </li>
      </ul>
    </div>
  </nav>
</div>
